import MobileCheck from "../utils/MobileCheck";

export default class SectionOverlay {
    static init() {
        if (MobileCheck.isMobileOrTablet()) {
            return;
        }

        let sectionOverlays = document.querySelectorAll('.section-overlay');

        sectionOverlays.forEach(overlay => {
            document.body.addEventListener('mousemove', function (e) {
                let circle = overlay.querySelector('.circle');
                let circleHalf = circle.offsetWidth / 2;

                // overlay.style.setProperty("--clip-position", `${(e.pageX - circleHalf)}px ${(e.pageY - circleHalf)}px`);
                overlay.style.maskPosition = `${(e.pageX - circleHalf)}px ${(e.pageY - circleHalf)}px`;
                circle.style.left = e.pageX - circleHalf + 'px';
                circle.style.top = e.pageY - circleHalf + 'px';
            });
        });
    }
}